import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import sk from '../i18n/sk.ts';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { sk },
    current: 'sk',
  },
  theme: {
    themes: {
      light: {
        primary: '#000000',//'#1c69d4',
        secondary: '#00838F',
        // anchor: '#8c9eff',
      },
    },
  },
});
